export default __webpack_public_path__ + "static/media/awaiting2S.a119fc33.svg";